function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.299805 5.50005C0.299805 3.4566 1.95635 1.80005 3.9998 1.80005H8.4998C8.8864 1.80005 9.1998 2.11345 9.1998 2.50005C9.1998 2.88665 8.8864 3.20005 8.4998 3.20005H3.9998C2.72955 3.20005 1.6998 4.22979 1.6998 5.50005V12C1.6998 13.2703 2.72955 14.3 3.9998 14.3H10.4998C11.7701 14.3 12.7998 13.2703 12.7998 12V7.50005C12.7998 7.11345 13.1132 6.80005 13.4998 6.80005C13.8864 6.80005 14.1998 7.11345 14.1998 7.50005V12C14.1998 14.0435 12.5433 15.7 10.4998 15.7H3.9998C1.95635 15.7 0.299805 14.0435 0.299805 12V5.50005Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 8.79995C10.3868 8.79995 10.7002 9.11335 10.7002 9.49995C10.7002 9.88655 10.3868 10.2 10.0002 10.2L6.5002 10.2C6.1136 10.2 5.8002 9.88655 5.8002 9.49995V5.99995C5.8002 5.61335 6.1136 5.29995 6.5002 5.29995C6.8868 5.29995 7.2002 5.61335 7.2002 5.99995L7.2002 7.81L13.5052 1.50498C13.7786 1.23161 14.2218 1.23161 14.4952 1.50498C14.7685 1.77834 14.7685 2.22156 14.4952 2.49493L8.19015 8.79995H10.0002Z",
  fill: "#738BA5"
});

function SvgCollapseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/CollapseIcon.5c267322.svg";
export { ForwardRef as ReactComponent };